import { schedulingUrl } from "@/config/scheduling";

const SchedulingCalendar = () => (
  <div data-testid="scheduling-calendar" className="w-full border border-line bg-white">
    <iframe
      title="Book a 15-minute consultation with Aspen Makkar"
      data-testid="scheduling-calendar-iframe"
      src={schedulingUrl}
      className="h-[720px] w-full min-w-[320px] border-0"
      loading="lazy"
    />
    <p className="border-t border-line bg-paper px-6 py-4 text-[10px] uppercase tracking-[0.25em] text-ash">
      15 minutes · Discovery call · No pitch, just clarity
    </p>
  </div>
);

export default SchedulingCalendar;
